// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3XsZ2","title":"ClientInsurance_title__2E-0n","itemText":"ClientInsurance_itemText__3xvZD"};